<template>
  <div class="accordeon fade-up" v-in-viewport.once>
    <div class="inner">
      <div class="container-2">
        <p class="ttl font-34 f-roman">{{ getTitle }}</p>
      </div>
      <div
        class="item"
        :class="{ active: active === _.get(item, 'id') }"
        v-for="(item, index) in _.orderBy(getData, 'sort', 'asc')"
        :key="index"
      >
        <div class="top-cont container-2" @click="openSlide(_.get(item, 'id'))">
          <p class="txt font-21 f-roman">{{ _.get(item, 'title') }}</p>
          <div class="icon" v-if="active !== _.get(item, 'id')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25.001"
              height="25"
              viewBox="0 0 25.001 25"
            >
              <path
                id="Union_14"
                data-name="Union 14"
                d="M6309.67,6946.5V6937h-9.5a1.5,1.5,0,1,1,0-3h9.5v-9.5a1.5,1.5,0,1,1,3,0v9.5h9.5a1.5,1.5,0,0,1,0,3h-9.5v9.5a1.5,1.5,0,1,1-3,0Z"
                transform="translate(6948 -6298.671) rotate(90)"
                fill="#0d1317"
              />
            </svg>
          </div>
          <div class="icon" v-if="active === _.get(item, 'id')">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="3" viewBox="0 0 25 3">
              <path
                id="Union_14"
                data-name="Union 14"
                d="M6312.671,6924.5v22a1.5,1.5,0,0,1-3,0v-22a1.5,1.5,0,0,1,3,0Z"
                transform="translate(6948 -6309.671) rotate(90)"
                fill="#0d1317"
              />
            </svg>
          </div>
        </div>
        <slide-up-down :active="active === _.get(item, 'id')" :duration="600">
          <div class="content container-2">
            <p class="font-16 f-medium">
              {{ _.get(item, 'answer') }}
            </p>
          </div>
        </slide-up-down>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['contentData'],
  data() {
    return {
      active: false,
      currentActive: false,
    };
  },
  methods: {
    openSlide(id) {
      this.currentActive = !this.currentActive;
      if (this.currentActive) {
        this.active = id;
      } else {
        this.active = false;
      }
    },
  },
  computed: {
    getData() {
      return _.get(this.contentData, 'data.list');
    },
    getTitle() {
      return _.get(this.contentData, 'conf.header.title');
    },
  },
};
</script>

<style lang="scss">
.accordeon {
  &.fade-up.in-view-port {
    opacity: 1;
    transform: translateY(0px);
  }
  padding-top: 103px;
  padding-bottom: 103px;
  background: var(--thirdy-tranparent);
  .item {
    position: relative;
    &.active {
      background-color: var(--white-bg);
      .txt::after {
        content: '';
        position: absolute;
        left: -30px;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 25px;
        border-radius: 5px;
        background: var(--red);
        transition: 0.6s;
      }
      .top-cont {
        &::after {
          opacity: 0;
        }
      }
    }
    padding-top: 50px;
    .content {
      border-bottom: 1px solid #d6d6d7;
      padding-bottom: 56px;
      color: var(--bonus-txt);
      transition: 0.4s ease-in-out;
      p {
        color: var(--bonus-txt);
        transition: 0.4s ease-in-out;
      }
    }
    .top-cont {
      transition: 0.6s;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding-bottom: 56px;
      position: relative;
      &::after {
        opacity: 1;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #d6d6d7;
        transition: 1s;
      }
      .txt {
        position: relative;
        padding-right: 20px;
        color: var(--lightGray-txt);
        transition: 0.6s;
      }
    }
  }
  .ttl {
    color: var(--white-no-blue2);
    position: relative;
    display: inline;
  }
}
</style>
